<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>IT Consulting</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>IT Consulting</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>IT Consulting</h3>
                    <p>IT consulting services are advisory services that help clients assess different technology
                        strategies and, in doing so,
                        align their technology strategies with their business or process strategies. These services
                        support customers’ IT
                        initiatives by providing strategic, architectural, operational and implementation planning.
                        Strategic planning includes
                        advisory services that help clients assess their IT needs and formulate system implementation
                        plans. Architecture
                        planning includes advisory services that combine strategic plans and knowledge of emerging
                        technologies to create the
                        logical design of the system and the supporting infrastructure to meet customer requirements.
                        Operational
                        assessment/benchmarking include services that assess the operating efficiency and capacity of a
                        client’s IT environment.
                        Implementation planning includes services aimed at advising customers on the rollout and testing
                        of new solution
                        deployments.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/professional-resourcing-services">
                            <img src="assets/img/services/services-7.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a routerLink="/professional-resourcing-services">Professional
                                Resourcing</a></h3>
                        <span>Contact us for more details</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/software-outsourcing-services">
                            <img src="assets/img/services/services-8.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/software-outsourcing-services">Software Outsourcing</a>
                        </h3>
                        <span>Contact us for more details</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->